
import React, { useState } from 'react'
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import usePtp from 'src/hooks/usePtp';
import ModalPtpPreguntas from 'src/pages/NewFinCompra/ModalPtpPreguntas';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { POST, guardarLead } from 'src/services';
import { Layout } from '../styleds';
import { useHistory } from 'react-router-dom';
import { urlFormaPago } from 'src/services/urls';
import franquicias from 'src/assets/img/franquicias.png'

let err = ""

const PlaceToPay = ({ codCore }) => {
  const { idCotizacion, cotizacion } = useCotizacion();
  const history = useHistory();

  const { setLoading, resetLoading, valdiarTerminos } = usePaginaPago();
  const { getUrl } = usePtp();

  const { addWarningToast } = useCustomToast();


  const pagarPtp = async () => {

    const Data = {
      idCotizacion: idCotizacion,
      forma: 'PTP',
      empCodigo: cotizacion?.empAplica
    };

    const res1 = await POST(urlFormaPago, Data);
    if (!res1.transaccion && res1.error) {
      addWarningToast(
        'Ha ocurrido un problema al seleccionar la forma de pago , por favor intente nuevamente.',
      );
      return
    }

    setLoading({
      loading: true,
      principal: 'Procesando',
      secundario: 'Pronto seras redireccionado a Place to Pay',
    });

    guardarLead(idCotizacion, `PAGINA_PAGO__SELECCIONO_P2P`);

    const res = await getUrl();
    const { hasError, url } = res
    err = res.hasError;

    if (hasError) {
      resetLoading();
      addWarningToast(typeof hasError == "string" ? hasError : 'HA OCURRIDO UN PROBLEMA AL REDIRECCIONAR A PLACE TO PAY');
      return;
    } else
      window.location.href = url;
  };

  console.log("cotizacion?.historialPago?.length", cotizacion?.historialPago?.length, cotizacion?.historialPago)

  return (
    <div className="row justify-content-center flex-column  py-4">
      <Layout>
        <img
          onClick={valdiarTerminos(pagarPtp)}
          className="logo"
          style={{ width: 180 }}
          src="https://static.placetopay.com/placetopay-logo.svg"
          alt="PLACE TO PAY"
        />
      </Layout>
      {cotizacion?.historialPago?.length > 0 &&
        <BtnPrincipal label="Mis pagos" onClick={() => history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}`)} />
      }
      <div className="text-center" >
        <img className="img-fluid" src={franquicias} alt="img-franquicias" style={{ maxHeight: 40 }} />
      </div>
      <ModalPtpPreguntas />
    </div>
  );
};

export default PlaceToPay;
